import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./index.css";
import "./styles/form.css";
import "./styles/App.css";
import "./styles/courses.css";
import "./styles/@mobi-768.css";

import { SigninPage } from "./features/authentication/signin";
import { SignupPage } from "./features/authentication/signup";
import { AddAvatar } from "./features/authentication/add-avatar";
import { AuthenticationContextProvider } from "./services/authentication/authentication.context";
import { ProtectedRoute } from "./components/authentication/protected-route";
import { UserAccount } from "./features/authentication/myaccount";
import { Unfound } from "./features/unfound/unfound";
import { HomePage } from "./features/home/home-page";
import { LessonPage } from "./features/courses/lessons";
import { LessonAddPage } from "./features/courses/create-lesson";
import { LessonContextProvider } from "./services/lessons/lessons.context";
import { CoursePage } from "./features/courses/course-page";
import { CourseAddPage } from "./features/courses/create-course";
import { CategoryAddPage } from "./features/courses/create-category";
import { EvalAddPage } from "./features/evaluation/create-eval";
import { ResetEmail } from "./features/authentication/password-reset-mail";
import { AboutUs } from "./features/home/about";
import { ContactUs } from "./features/home/contact";
import { AiChatPage } from "./features/admin/aichat";
import { GlobalClassroom } from "./global-classroom/global-classroom";
import { ProjectPlayground } from "./playground/playground";
import ScrollToTopButton from "./components/utilities/scroll-to-top";
import { UpdateQuestion } from "./features/evaluation/update-question";
import { PlacementPage } from "./features/placement/placement.questions";


function App() {
  return (

    <BrowserRouter>
      <AuthenticationContextProvider>
        <LessonContextProvider>
          <ScrollToTopButton />
          <Routes>
            <Route path="*" element={<Unfound />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<SigninPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/courses" element={<LessonPage />} />
            <Route path="/resetemail" element={<ResetEmail />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/playground" element={<ProjectPlayground />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/avatar" element={<AddAvatar />} />
              <Route path="/myaccount" element={<UserAccount />} />
              <Route path="/addlesson" element={<LessonAddPage />} />
              <Route path="/addcourse" element={<CourseAddPage />} />
              <Route path="/addcategory" element={<CategoryAddPage />} />
              <Route path="/course" element={<CoursePage />} />
              <Route path="/createval" element={<EvalAddPage />} />
              <Route path="/aichat" element={<AiChatPage />} />
              <Route path="/gclassroom" element={<GlobalClassroom />} />
              <Route path="/playground" element={<ProjectPlayground />} />
              <Route path="/updatequestion" element={<UpdateQuestion />} />
              <Route path="/placement" element={<PlacementPage />} />
            </Route>
          </Routes>
        </LessonContextProvider>
      </AuthenticationContextProvider>
    </BrowserRouter>
  );
}

export default App;
